<template>
  <div>
    <b-table
      style="
        background-color: whitesmoke;
        border-radius: 1rem;
        text-align: center;
      "
      :items="timerList"
      :fields="fields"
      hover
      responsive
      no-border-collapse
      v-if="getTimers.length !== null"
    >
      <template #cell(id)="row">
        <v-col style="margin-left: 1px; margin-right: 1px">
          {{ row.index + 1 }}<br />
        </v-col>
      </template>
      <template #cell(project)="row">
        <v-col style="margin-left: 1rem; text-align: left">
          <div>
            <h6
              @click="gotoLink(row.item.project_id)"
              v-if="checkLink(row.item.project_id)"
              style="color: blue; font-size: 25px; font-weight: bold"
              type="button"
              v-b-tooltip.left.hover
              title="Click title to redirect to gitlab board"
            >
              {{ mapIdToProjectName(getProjectNameList, row.item.project_id) }}
            </h6>
            <h6 v-else>
              {{ mapIdToProjectName(getProjectNameList, row.item.project_id) }}
            </h6>
          </div>
          <p
            class="project_description"
            v-if="modifyDescription[row.index] === false"
            @dblclick="toggleQuickDescription(row.item, row.index)"
          >
            {{ row.item.task_description }}
          </p>
          <div
            v-if="modifyDescription[row.index] === true"
            style="display: flex"
          >
            <b-textarea
              style="min-width: 250px"
              v-model="description"
              @blur="quickDescriptionUpdate(row.item, row.index)"
              autofocus
            >
            </b-textarea>
            <v-btn
              class="ml-2"
              x-small
              fab
              @click="quickDescriptionUpdate(row.item, row.index)"
              color="green"
            >
              <v-icon small color="white">mdi-check</v-icon>
            </v-btn>
          </div>
        </v-col>
      </template>
      <template #cell(actions)="row">
        <v-col style="">
          <v-btn
            fab
            v-if="isRowRunning(row.item)"
            v-on:click="updateTimer(row.item)"
            color="red"
            :disabled="timerControlsDisabled"
          >
            <v-icon large color="white">mdi-stop</v-icon>
          </v-btn>
          <v-btn
            fab
            v-else
            v-on:click="updateTimer(row.item)"
            color="green"
            :disabled="timerControlsDisabled"
          >
            <v-icon large color="white">mdi-play</v-icon>
          </v-btn>
          <v-btn
            fab
            v-on:click="editTimerLog(row.item, row.index, $event.target)"
            color="#2722a6"
          >
            <v-icon large color="white">mdi-pen</v-icon>
          </v-btn>
        </v-col>
      </template>
      <template #cell(display)="row">
        <v-col class="padding-nav-bar" v-if="isRowRunning(row.item)">
          <v-card-text style="text-align: center; font-size: 20px">
            {{ displayHoursForRow(row.item) }}
          </v-card-text>
        </v-col>
        <v-col v-else>
          <v-card-text style="text-align: center; font-size: 20px">
            {{ displayHoursForRow(row.item) }}
          </v-card-text>
        </v-col>
      </template>
      <template #cell(status)="row">
        <v-col v-if="isRowRunning(row.item)" style="">
          <v-card-text
            style="text-align: center; font-size: 20px; font-style: italic"
            >Running
          </v-card-text>
        </v-col>
        <v-col v-else style="">
          <v-card-text style="text-align: center; font-size: 20px"
            >Stopped
          </v-card-text>
        </v-col>
      </template>
      <template #top-row v-if="isTimerListEmpty">
        <v-col>
          <div style="text-align: center" class="text-h5">
            No Time log entries found for the day
          </div>
        </v-col>
      </template>
      <template #bottom-row>
        <b-td></b-td>
        <b-td></b-td>
        <b-td>
          <v-col v-if="!isTimerListEmpty">
            Day Total :
            {{ convertToHm(getTotalSecondsToday()) }}
          </v-col>
        </b-td>
        <b-td>
          <v-col>
            <!-- [TODO-> need to setup backend data]         This Week : {{ convertTime(getTotalHourToday()) }}-->
          </v-col>
        </b-td>
        <b-td>
          <v-col>
            <!--[TODO-> need to setup backend data]          This Month : {{ convertTime(getTotalHourToday()) }}-->
          </v-col>
        </b-td>
      </template>
    </b-table>
    <EditTimerModal :edit-modal="editModal" />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import EditTimerModal from "@/components/Timer/EditTimerModal";
import {
  GetCurrentTimeUtc,
  HHMMSStoSeconds,
  HHMMSStoHours,
  convertToHm,
  displayHmFromDecimalHours,
  hoursDecimalToDisplayMinuteSeconds,
  UpdateCurrentTimerData,
  CheckIfTimerIsRunningToday,
  today,
} from "@/Utilites/timerHelper";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
import {mapIdToProjectName} from "@/Utilites/clipBoardHelper";
import {removeEmptyLines} from "@/Utilites/helper";
import {
  isActiveTimerRow,
  resolveLogBaseHours,
  shouldShowV1SessionOnDate,
  shouldStopV1ForRow,
  confirmTimerStartOnNonToday,
} from "@/services/timerV1Mapper";

export default {
  name: "TimerPageTableView",
  components: {
    EditTimerModal,
  },
  data() {
    return {
      fields: [
        {key: "id", label: "Logs", thStyle: {display: "id"}},
        {key: "project", label: "Project", thStyle: {display: "project"}},
        {key: "display", label: "Hours", thStyle: {display: "display"}},
        {key: "status", label: "Status", thStyle: {display: "status"}},
        {key: "actions", label: "Controls", thStyle: {display: "actions"}},
      ],
      editModal: {
        id: "edit-modal",
        index: "",
        item: "",
      },
      modifyDescription: [],
      description: "",
      startTime: "",
      interval: null,
      projects: [],
    };
  },
  props: {
    timerList: {},
    timerControlsDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "getTimers",
      "getProjects",
      "getCurrentActiveTimer",
      "getCurrentActiveTimerTime",
      "getProjectNameList",
      "isTimerV1Active",
      "getTimerV1Session",
    ]),
    isTimerListEmpty() {
      return this.getTimers.length === 0;
    },
    checkCurrentState() {
      return CheckIfTimerIsRunningToday(this.getTimers);
    },
  },
  watch: {
    timerList: function () {
      this.setNbModifyDescription(this.timerList.length);
    },
  },
  methods: {
    ...mapActions([
      "showSnackBar",
      "closeSnackBar",
      "fetchProjectNameOnly",
      "UPDATE_TIMER_REQUEST",
      "TIMER_V1_START",
      "TIMER_V1_STOP",
      "showLoadingProcess",
      "closeLoading",
    ]),
    ...mapMutations(["ACTIVATE_TIMER", "CACHE_TIMER_LOG_HOURS"]),
    convertToHm,
    mapIdToProjectName,
    toggleQuickDescription(rowItem, index) {
      this.$set(this.modifyDescription, index, true);
      this.description = rowItem.task_description;
      if (this.description === "<Please Enter a Description Here>") {
        this.description = "";
      }
    },
    async quickDescriptionUpdate(rowItem, index) {
      this.$set(this.modifyDescription, index, false);
      this.description = removeEmptyLines(this.description);
      if (this.description === "") {
        this.description = "<Please Enter a Description Here>";
      }
      rowItem.task_description = this.description;
      rowItem.log_description = rowItem.task_description;
      await this.UPDATE_TIMER_REQUEST({...rowItem});
    },
    checkLink(id) {
      let projectBoardUrl = "";
      this.getProjects.map((oneProject) => {
        if (oneProject.id === id) {
          projectBoardUrl = oneProject.source_control_link1;
        }
      });
      return !(projectBoardUrl === "" || projectBoardUrl === null);
    },
    gotoLink(id) {
      let projectBoardUrl = "";
      this.getProjects.map((oneProject) => {
        if (oneProject.id === id) {
          projectBoardUrl = oneProject.source_control_link1;
        }
      });
      window.open(projectBoardUrl, "_blank").focus();
    },
    setNbModifyDescription(number) {
      this.modifyDescription = [];
      for (let i = 0; i < number; i++) {
        this.modifyDescription.push(false);
      }
    },
    isRowRunning(rowItem) {
      const active = this.getCurrentActiveTimer;
      if (this.isTimerV1Active) {
        const v1 = this.getTimerV1Session;
        const viewDate = this.$store.state.timer.viewingTimerLogDate;
        const list = this.$store.state.timer.timerLogsList || [];
        if (!shouldShowV1SessionOnDate(v1, list, viewDate)) {
          return rowItem.timer_started_at != null;
        }
        if (v1 && v1.status === "active") {
          return isActiveTimerRow(rowItem, active, v1);
        }
        if (active && active.id != null) {
          return isActiveTimerRow(rowItem, active, v1);
        }
        return false;
      }
      return rowItem.timer_started_at != null;
    },
    displayHoursForRow(rowItem) {
      if (!this.isRowRunning(rowItem)) {
        return displayHmFromDecimalHours(resolveLogBaseHours(rowItem));
      }
      return this.getCurrentActiveTimerTime;
    },
    getTotalSecondsToday() {
      let totalSeconds = 0;
      const active = this.getCurrentActiveTimer;
      this.getTimers.forEach((item) => {
        if (
          active &&
          active.id != null &&
          String(item.id) === String(active.id)
        ) {
          totalSeconds += HHMMSStoSeconds(this.getCurrentActiveTimerTime);
        } else {
          // Match per-row HH:MM display (minute-rounded), not raw stored decimals.
          totalSeconds += hoursDecimalToDisplayMinuteSeconds(
            resolveLogBaseHours(item)
          );
        }
      });
      return totalSeconds;
    },
    async updateTimer(rowItem) {
      if (this.timerControlsDisabled) return;
      if (this.isTimerV1Active) {
        await this.updateTimerV1(rowItem);
        return;
      }
      let timerData = {
        id: rowItem.id,
        user_id: rowItem.user_id,
        project_id: rowItem.project_id,
        log_description: rowItem.task_description,
        task_description: rowItem.task_description,
        log_date: rowItem.timer_log_date,
        timer_log_date: rowItem.timer_log_date,
        working_hours: rowItem.hours,
        hours: rowItem.hours,
        hours_with_timer: rowItem.hours,
        is_submitted: true,
      };
      try {
        if (
          rowItem.timer_started_at == null &&
          this.getCurrentActiveTimer.id === undefined
        ) {
          await this.currentTimerUpdate(timerData);
          timerData.timer_started_at = GetCurrentTimeUtc();
          timerData.timer_initiated_at = timerData.timer_started_at;
          timerData.timer_stopped_at = null;
          await this.UPDATE_TIMER_REQUEST({
            ...timerData,
          });
          return;
        }
        if (
          rowItem.timer_started_at != null &&
          rowItem.id === this.getCurrentActiveTimer.id
        ) {
          let endTime = GetCurrentTimeUtc();
          let hours = HHMMSStoHours(this.getCurrentActiveTimerTime);
          timerData.hours_with_timer = hours;
          timerData.hours = hours;
          timerData.timer_started_at = null;
          timerData.timer_stopped_at = endTime;
          timerData.working_hours = hours;
          await this.UPDATE_TIMER_REQUEST({
            ...timerData,
          });
        }
      } catch (err) {
        console.log(JSON.stringify(err));
      } finally {
        await this.closeLoading();
      }
    },
    async updateTimerV1(rowItem) {
      await this.showLoadingProcess();
      try {
        const list = this.$store.state.timer.timerLogsList || [];
        const latest =
          list.find((t) => String(t.id) === String(rowItem.id)) || rowItem;
        const active = this.getCurrentActiveTimer;
        const v1 = this.getTimerV1Session;
        if (shouldStopV1ForRow(latest, v1, active)) {
          await this.TIMER_V1_STOP({});
          return;
        }
        const logDate = latest.timer_log_date || latest.log_date;
        if (!confirmTimerStartOnNonToday(logDate)) {
          return;
        }
        if (logDate && logDate !== today()) {
          this.showSnackBar({
            text: `Timer running on ${logDate} (not today).`,
            color: DEFAULT_CONSTANTS.warn,
          });
        }
        // TIMER_V1_START already sets the session, activates the row, and
        // starts the display tick — an extra SYNC here just adds a full
        // network round-trip (up to 8s) behind the blocking spinner.
        await this.TIMER_V1_START({
          project_id: latest.project_id,
          task_description: latest.task_description,
          legacy_timer_log_id: latest.id,
          timer_log_date: logDate,
        });
      } catch (err) {
        console.error("[timer v1] row toggle failed", err);
        const detail = (err && err.message) || String(err);
        await this.showSnackBar({
          text: `Timer could not start: ${detail}`,
          color: DEFAULT_CONSTANTS.error,
        });
      } finally {
        await this.closeLoading();
      }
    },
    async currentTimerUpdate(timerData) {
      let currentTimer = {...this.getCurrentActiveTimer};
      if (currentTimer.id !== undefined && currentTimer.id !== timerData.id) {
        let data = UpdateCurrentTimerData(currentTimer);
        await this.UPDATE_TIMER_REQUEST({...data});
      }
    },
    editTimerLog(items, index) {
      this.editModal.index = index;
      this.editModal.item = items;
      this.$bvModal.show(this.editModal.id);
    },
  },
};
</script>

<style scoped>
.project_description {
  white-space: pre-line;
}
</style>
